import { notify } from "@kyvg/vue3-notification";
import { defineStore } from "pinia";

import { CREATE_RENDER, GENERATE_PREVIEW_API } from "@/components/Render/service/api";

export const useRenderStore = defineStore("renderStore", {
  state: () => ({
    selectedModelForRender: null,
    renderStep: 1,
    render: null,
    shadersRender: [],
    loadRenderData: false,
    isRenderWidgetLoaded: false,
    renderTab: 0,
    renderChangeScaleWhilePreview: false,
    renderChangeHDRIWhilePreview: false,
    isUseBuildInMaterial: false,
    selectedRenders: [],
    allRenders: [],
    isLoadingBtnPreview: false,
  }),
  getters: {
    hasSelectedRenders: (state) => {
      return state.selectedRenders?.length > 0;
    },
  },
  actions: {
    setRenderTab(value) {
      this.renderTab = value;
    },
    setLoadingBtnPreview(value) {
      this.isLoadingBtnPreview = value;
    },
    setRender(value) {
      this.render = value;
    },
    setValue(keyValue) {
      if (keyValue?.key in this) {
        this[keyValue.key] = keyValue.value;
      }
    },
    setMaterialRender(data) {
      let _shadersRender = [...this.shadersRender];
      _shadersRender = _shadersRender.filter((_shader) => {
        return _shader.id !== data.shader.id;
      });
      _shadersRender.push({
        ...data.shader,
        render_material: data.material,
      });
      this.shadersRender = _shadersRender;
    },
    deleteMaterialRender(shader) {
      let _shadersRender = [...this.shadersRender];
      _shadersRender = _shadersRender.filter((_shader) => {
        return _shader.id !== shader.id;
      });
      this.shadersRender = _shadersRender;
    },
    addSelectedRender(render) {
      const getId = (r) => r?.uuid;
      const id = getId(render);
      const exists = this.selectedRenders.some((r) => getId(r) === id);
      if (!exists) this.selectedRenders.push(render);
    },
    removeSelectedRender(render) {
      const getId = (r) => r?.id ?? r?.uuid ?? r;
      const id = getId(render);
      this.selectedRenders = this.selectedRenders.filter((r) => getId(r) !== id);
    },
    setSelectedRenders(renders) {
      this.selectedRenders = renders;
    },
    updateRenderStatus({ uuid, status }) {
      const render = this.allRenders.find((r) => r.uuid === uuid);
      if (render) render.status = status;
    },
    removeRender(uuid) {
      this.allRenders = this.allRenders.filter((r) => r.uuid !== uuid);
    },

    SET_VALUE(keyValue) {
      this.setValue(keyValue);
    },
    SET_MATERIAL_RENDER(data) {
      this.setMaterialRender(data);
    },
    DELETE_MATERIAL_RENDER(shader) {
      this.deleteMaterialRender(shader);
    },
    ADD_SELECTED_RENDER(render) {
      this.addSelectedRender(render);
    },
    REMOVE_SELECTED_RENDER(render) {
      this.removeSelectedRender(render);
    },
    CLEAR_ALL_RENDERS() {
      this.setSelectedRenders([]);
    },
    SELECT_ALL_RENDERS() {
      this.setSelectedRenders([...this.allRenders]);
    },
    async GENERATE_PREVIEW() {
      try {
        this.setRenderTab(1);
        this.setLoadingBtnPreview(true);
        await GENERATE_PREVIEW_API(this.render);
        if (this.render) {
          this.setRender({ ...this.render, status: "pending" });
        }
        notify({
          group: "foo",
          title: "Генерация превью успешно запущена",
          type: "success",
        });
      } catch (e) {
        notify({
          group: "foo",
          title: "Генерация превью НЕ запущена",
          type: "error",
        });
        console.error("fail start render preview, ", e);
      } finally {
        this.setLoadingBtnPreview(false);
      }
    },
    async CREATE_RENDER(params) {
      try {
        const payload = { ...params };
        const resp = await CREATE_RENDER(payload);
        notify({
          group: "foo",
          title: "Рендер успешно создан",
          type: "success",
        });
        this.setValue({ key: "render", value: resp });
        this.allRenders.push(resp);
        return resp;
      } catch (error) {
        notify({
          group: "foo",
          title: "Рендер не был создан",
          type: "error",
        });
        console.error("fail create render, ", error);
      }
    },
  },
});

export default useRenderStore;
